import React, { Component, Context } from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { IPeerSupportActionDispatches, mapPeerSupportDispatchToProps } from "../../../redux/actions/peerSupport";
import { IPeerSupportState, mapPeerSupportStateToProps } from "../../../redux/reducers/peerSupport";
import LayoutContext, { ILayoutContext } from "../../../contexts/layout/LayoutContext";
import { IPSAgent } from "../../../models/peer-support";
import UILoader from "../../ui/UILoader";
import AgentsList from "./AgentsList";
import { AgentssHeader } from "./AgentsHeader";
import { AgentDetail } from "./AgentDetail";
const queryString = require("query-string");

type AgentsState = {
	loading: boolean;
	searchQuery: string;
	filterAdmins: boolean;
	idToDelete: string;
};

const queryAgent = (member: IPSAgent, queries: string[]): boolean => {
	let result: boolean = false;
	queries.forEach((query: string) => {
		const q: string = query?.trim();
		if (
			member.first_name.toLowerCase().includes(q) ||
			member.last_name.toLowerCase().includes(q) ||
			`${member.first_name.toLowerCase()} ${member.last_name.toLowerCase()}`.includes(q) ||
			member.email.toLowerCase().includes(q) ||
			(member.homeAddress && member.homeAddress.zip_code && member.homeAddress.zip_code.includes(q)) ||
			(member.workAddress && member.workAddress.zip_code && member.workAddress.zip_code.includes(q)) ||
			member.mobile_number.toLowerCase().includes(q) // dana TODO member privacy
		)
			result = true;
		return result;
	});
	return result;
};

class Agents extends Component<IPeerSupportActionDispatches & IPeerSupportState & RouteComponentProps, AgentsState> {
	private queryStringQuery: string = "";
	static contextType: Context<ILayoutContext> = LayoutContext;

	state = {
		loading: true,
		searchQuery: "",
		filterAdmins: false,
		idToDelete: undefined,
	};

	get agents(): IPSAgent[] {
		let agents: IPSAgent[] = this.props.agents || [];
		if (this.state.searchQuery) {
			const q: string = this.state.searchQuery.toLowerCase();
			const joinQuery: string[] = q.split(",");
			agents = this.props.agents.filter((agent: IPSAgent) => queryAgent(agent, joinQuery));
		}
		if (this.state.filterAdmins) {
			agents = agents.filter(
				(agent: IPSAgent) =>
					(agent.role || "").toLowerCase().includes("admin") ||
					(agent.role || "").toLowerCase().includes("coordinator")
			);
		}
		return agents;
	}

	componentDidMount() {
		const parsed = queryString.parse(this.props.location.search);
		if (parsed && parsed.q) {
			this.setState({ searchQuery: parsed.q });
			this.queryStringQuery = parsed.q;
		}
		// dana sheri load peer teams if user role team lead and above. maybe members too
		this.props.loadAgents().then(() => {
			this.setState({ loading: false });
		});
	}

	deleteAgent(facility: IPSAgent) {
		console.log("deleteAgent:", facility);
		return this.props.deleteAgent(facility).then(() => {
			this.setState({ idToDelete: facility.id });
			setTimeout(() => {
				this.setState({ idToDelete: undefined });
			}, 300);
		});
	}

	render() {
		if (this.state.loading) return <UILoader display={true} />;
		// check if it's a detail page
		const arr = this.props.location.pathname.split("/");
		const agentId: string = arr.length ? arr[arr.length - 1] : undefined;
		let agent: IPSAgent;
		if (agentId && agentId !== "peers") {
			agent = this.props.agents.find((a: IPSAgent) => a.id === agentId);
			if (agent)
				return (
					<div className="animated fadeInRight fast-1">
						<AgentDetail
							agent={agent}
							onEditAgent={(data, id) => this.props.editAgent(data, id)}
							onDeleteAgent={(data) => this.deleteAgent(data)}
						/>
					</div>
				);
		}

		return (
			<div className="container my-4 pb-2">
				<AgentssHeader
					defaultValue={this.queryStringQuery}
					onSearch={(val) => this.setState({ searchQuery: val })}
					onFilterAdmins={(val: boolean) => {
						this.setState({ filterAdmins: val });
					}}
					addAgent={(data) => this.props.addAgent(data)}
				/>
				{this.state.loading && <UILoader display={true} />}
				{!this.state.loading && (
					<AgentsList
						agents={this.agents}
						idToDelete={this.state.idToDelete}
						onEditAgent={(data, id) => this.props.editAgent(data, id)}
						onDeleteAgent={(data) => this.deleteAgent(data)}
					/>
				)}
			</div>
		);
	}
}

export default connect<IPeerSupportState, IPeerSupportActionDispatches>(
	mapPeerSupportStateToProps,
	mapPeerSupportDispatchToProps
)(withRouter(Agents));
